import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup, FormGroup, Input, Label, Badge } from 'reactstrap'
import toastr from 'toastr'

import Modal from '../../../components/Modal'
import {
    PROGRAMACION_INTERVALOS,
    submitProgramacionFactura
} from '../../../helpers/facturasProgramadas'

const toDateValue = (date) => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

const ProgramarFacturaModal = ({
    facturaId,
    isOpen,
    onRequestClose,
    history,
    initialSchedule,
    title,
    submitLabel,
    onSuccess
}) => {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    const [isRecurring, setIsRecurring] = useState(Boolean(initialSchedule?.isRecurring))
    const [interval, setInterval] = useState(initialSchedule?.interval || 'mensual')
    const [submitting, setSubmitting] = useState(false)
    const [scheduledFor, setScheduledFor] = useState(
        toDateValue(initialSchedule?.scheduledFor || tomorrow)
    )

    useEffect(() => {
        if (!isOpen) return

        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)

        setScheduledFor(toDateValue(initialSchedule?.scheduledFor || tomorrow))
        setIsRecurring(Boolean(initialSchedule?.isRecurring))
        setInterval(initialSchedule?.interval || 'mensual')
    }, [initialSchedule, isOpen])

    const onSubmit = async () => {
        try {
            setSubmitting(true)
            const [year, month, day] = scheduledFor.split('-').map(Number)
            const localDate = new Date(year, month - 1, day, 0, 0, 0, 0)

            const payload = {
                scheduledFor: localDate.toISOString(),
                isRecurring
            }

            if (isRecurring) {
                payload.interval = interval
            }

            const response = await submitProgramacionFactura(facturaId, payload)
            if (!response.data?.success) {
                toastr.error(response.data?.message || 'No pude programar la factura.')
                return
            }

            toastr.success('La programación de la factura quedó guardada correctamente.')
            onRequestClose()
            if (onSuccess) {
                onSuccess(response)
                return
            }

            history.push('/facturas')
        } catch (error) {

            console.log(error)
            const message = error.response?.data?.message || 'No pude programar la factura.'

            toastr.error(message)
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <Modal
            title={title || 'Programar Factura'}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Programar Factura"
            body={(
                <>
                    <FormGroup>
                        <Label htmlFor="scheduledFor">Fecha programada</Label>
                        <Input
                            type="date"
                            id="scheduledFor"
                            min={toDateValue(new Date())}
                            value={scheduledFor}
                            onChange={(e) => setScheduledFor(e.target.value)}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label className="d-block">Recurrencia</Label>
                        <div className="d-flex align-items-center flex-wrap">
                            <ButtonGroup>
                                <Button
                                    color={isRecurring ? 'light' : 'primary'}
                                    outline={isRecurring}
                                    onClick={() => setIsRecurring(false)}
                                >
                                    Única
                                </Button>
                                <Button
                                    color={isRecurring ? 'primary' : 'light'}
                                    outline={!isRecurring}
                                    onClick={() => setIsRecurring(true)}
                                >
                                    Recurrente
                                </Button>
                            </ButtonGroup>
                            {isRecurring && (
                                <Badge color="warning" pill className="ml-2">
                                    Recurrente
                                </Badge>
                            )}
                        </div>
                    </FormGroup>

                    {isRecurring && (
                        <FormGroup className="mt-3">
                            <Label htmlFor="interval">Intervalo</Label>
                            <Input
                                type="select"
                                id="interval"
                                value={interval}
                                onChange={(e) => setInterval(e.target.value)}
                            >
                                {PROGRAMACION_INTERVALOS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    )}
                </>
            )}
            footer={(
                <>
                    <Button color="secondary" onClick={onRequestClose} disabled={submitting}>
                        Cancelar
                    </Button>
                    <Button color="primary" onClick={onSubmit} disabled={submitting}>
                        {submitLabel || 'Programar'}
                    </Button>
                </>
            )}
        />
    )
}

export default ProgramarFacturaModal
